import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

/** CRUD for agency checklist / workflow templates (common DB ChecklistAgency, WorkflowAgency). */
@Injectable({ providedIn: 'root' })
export class AgencyTemplateService {
  constructor(private http: HttpClient) {}

  private base(agencyId: string): string {
    return `${environment.apiBaseUrl}/agencies/${agencyId}`;
  }

  listChecklists(agencyId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.base(agencyId)}/checklist_templates`);
  }

  createChecklist(agencyId: string, body: Record<string, unknown>): Observable<any> {
    return this.http.post<any>(`${this.base(agencyId)}/checklist_templates`, body);
  }

  updateChecklist(agencyId: string, checklistId: string, body: Record<string, unknown>): Observable<any> {
    return this.http.put<any>(`${this.base(agencyId)}/checklist_templates/${checklistId}`, body);
  }

  deleteChecklist(agencyId: string, checklistId: string): Observable<any> {
    return this.http.delete<any>(`${this.base(agencyId)}/checklist_templates/${checklistId}`);
  }

  listWorkflows(agencyId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.base(agencyId)}/workflow_templates`);
  }

  createWorkflow(agencyId: string, body: Record<string, unknown>): Observable<any> {
    return this.http.post<any>(`${this.base(agencyId)}/workflow_templates`, body);
  }

  updateWorkflow(agencyId: string, workflowId: string, body: Record<string, unknown>): Observable<any> {
    return this.http.put<any>(`${this.base(agencyId)}/workflow_templates/${workflowId}`, body);
  }

  deleteWorkflow(agencyId: string, workflowId: string): Observable<any> {
    return this.http.delete<any>(`${this.base(agencyId)}/workflow_templates/${workflowId}`);
  }
}
